/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:20:37
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ашу",
    name2: "Резерв жасау",
    name3: "Carlcare көмегімен тапсырысыңызды кез келген уақытта тексеруіңізге болады.",
    name4: "",
    name5: "Оңға сырғытыңыз",
    name6: "Тексеріліп болды",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",

  },
  order: {
    name1: "Құрылғы үлгісін таңдау",
    name2: "Ақау сипаттамасы:",
    name3: "Қызмет дүкенін таңдау үшін түртіңіз",
    name4: "Қызмет көрсету дүкені:",
    name5: "Резерв уақыты:",
    name6: "Құрылғыңыздың ақаулығын толық сипаттаңыз!",
    name7: "Келу уақытын таңдау үшін түртіңіз",
    name8: "Сізге хабарласа алуымыз үшін байланыс мәліметтерін дұрыс енгізіңіз",
    name9: "Қолжетімді резервтеу уақыты төмендегідей",
    name10: "Телефон нөміріңізді жазыңыз",
    name11: "Баға",
    name12: "Жеке мәліметтер:",
    name13: "Атыңызды жазыңыз",
    name14: "Жіберу",
    name15: "Бас тарту",
    name16: "OK",
  },
  shops: {
    name1: "Сіз таңдаған брендке негізінде төмендегі дүкендер сізге қызмет көрсете алады!",
    name2: "Жақында қосымша бөлшек сауда дүкендерінде! Бізбен бірге болыңыз!",
  },
  price: {
    name1: "Бренд",
    name2: "Үлгі",
    name3: "ЭЛЕМЕНТ",
    name4: "Баға",
    name5: "Достық еске салғыш:",
    name6: "Бұл бағалар тек анықтама ретінде берілген және нақты баға құрылғының жағдайына байланысты болады.",
    name7: "Егер арнайы таңба болмаса, баға бірлігі жергілікті валюта бірлігі болады.",
    name8: "Кешіріңіз! Қазіргі аймақта бағалар туралы ақпарат жоқ.",
    name11:"Еңбек ақысы",
    name12:"Қорытынды баға",
    name13: "5. Еңбек құны «/» болса, ол еңбек құны жайлы дүкенмен ақылдасу керек дегенді білдіреді.",
    item_main_board: "Негізгі плата",
    item_screen_frame: "Экран (жақтау)",
    item_screen_screen_frame: "Қосымша экран (жақтау)",
    item_touch_screen: "Сенсорлы экран",
    item_camera: "\"Камера\"",
    item_fixed_focus_camera: "Тұрақты фокусты камера",
    item_auto_focus_camera: "Автоматты фокусты камера",
    item_screen: "Экран",
    item_secondary_screen: "Қосалқы экран",
    item_fingerprint_module: "Саусақ ізі модулі",
    item_speaker: "Динамик",
    item_receiver: "Қабылдауыш",
    item_small_board: "Шағын тақта",
    item_battery_cover: "Батарея қақпағы",
    item_battery: "Батарея",
    item_charger: "Қуаттау құралы",
    item_usb_cable: "USB кабель",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Дерекқор жоқ.",
    name2: "Сервис провайдері:",
    name3: "Сервистік бренд:",
    name4: "Телефон:",
    name5: "Тапсырыс саны:",
    name6: "Қызмет көрсету рейтингі",
    name7: "Қызмет көрсету ортасы:",
    name8: "Қызмет көрсету жағдайы:",
    name9: "Қызмет көрсету тиімділігі:",
    name10: "Қызмет көрсету сапасы:",
    name11: "Тұтынушы бағасы",
    name12:"және аралығында",
    name13:"Жабылды",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ашу",
    name1: "Басымдықты қызметке қол жеткізу үшін брондау туралы ақпараттың скриншотын түсіріп, түбіртек ретінде сақтаңыз.",
    name2: "Сәтті жіберілді",
    name3: "1. Деректерді тазалаңыз",
    name4: "Құпия деректердің сақтық көшірмесін телефоныңызға алдын ала жасаңыз.",
    name5: "2. Қуатты қосу құпия сөзін өшіріңіз",
    name6: "Қызмет көрсету дүкеніне барудан бұрын:",
    name7: "Қызмет көрсету дүкені:",
    name8: "Резерв уақыты:",
    name9: "Ақау сипаттамасы:",
    name10: "Құрылғы үлгісі:",
    name11: "Тапсырыс нөмірі:",
    name12: "Тапсырыс туралы ақпарат",
  },
  title: {
    
    name1: "Келесі елдерге қызмет көрсетіледі:",
    name2: "Үлгіні таңдау",
    name3: "Резервтеу",
    name4: "Қызмет көрсету дүкенінің мәліметтері",
    name5: "Қызмет көрсету дүкенін таңдау",
  },
  error: {
    
    name1: "Деректер жоқ. Жөндеу туралы ақпаратты тексеріңіз",
    name2: "Қосымша көмек керек пе? Бізге хабарласыңыз.",
    name3: "Кешіріңіз, бұл аймақта Carlcare орталығы жоқ.",
    name4: "Алдымен сервистік орталықты таңдаңыз",
    name5: "Сәтсіз аяқталды",
    name6: "Алдымен құрылғы моделін таңдаңыз",
    name7: "Егжей-тегжейі",
    name8: "Қажеттіліктеріңізді толық сипаттаңыз",
    name9: "",
  },
  add1:{
    "name0": "kk-rKZ",
    "name1": "Тапсырысыңыз расталды. Келуіңізді асыға күтіп отырмыз.",
    "name2": "Қала таңдау",
    "name3": "%1$s цифрдан тұратын телефон нөмірін енгізіңіз.",
    "name4": "Жұмыс күндері сағаттары",
    "name5": "Дүйсенбі",
    "name6": "Сейсенбі",
    "name7": "Сәрсенбі",
    "name8": "Бейсенбі",
    "name9": "Жұма",
    "name10": "Сенбі",
    "name11": "Жексенбі",
    "name12": "Елді енгізіп, іздеңіз"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "Басқалары",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Бағыттау үшін түртіңіз",
    name3:"Тапсырысты бағалау үшін Carlcare қолданбасын ашыңыз",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Қызмет таңдау",
    name7:"Тегін тазалау",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Қате ақпарат",
    "cancelReason1": "Уақытында келе алмаймын",
    "cancelReason2": "Қайталанған тапсырыс / менің тапсырысым емес",
    "cancelReason3": "Сәтсіз жағдай қайталанбайды",
    "cancelReason4": "Тек тест/сұрау/оқиға/…",
    "cancelReason5": "Жоғары баға",
    "cancelReason6": "Материал тапшы",
    "cancelReason7": "Дифференциалды қызметтер жоқ",
    "cancelReason8": "Дүкен тым алыс",
    "cancelReason9": "Дүкен жабық",
    "cancelReason10": "Қызмет көрсетуге деген нашар көзқарас",
    "cancelReason11": "Басқа маркалардың ауыстыру/жөндеу жұмысы",
    "cancelReason12": "Дүкенді табу мүмкін емес",
    "cancelReason13": "Басқа",
    "cancelOrder": "Тапсырыстан бас тарту",
    "reason_dialog_title": "Бас тарту себебін айтуыңызды өтінеміз",
    "Cancel": "Бас тарту",
    "OK": "Жарайды",
    "name1": "Тексеру кодын енгізіңіз",
    "name2": "Растау коды жарамсыз",
    "repair_reservation_detail_canceled": "Бұл тапсырыс Жойылды!",
    "purchase_cancel_dialog_content": "Тапсырыстан бас тартасыз ба?",
    "yes": "\"Иә\"",
    "no": "\"Жоқ\""
}
};
